import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=094c60fa&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=094c60fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094c60fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094c60fa')) {
      api.createRecord('094c60fa', component.options)
    } else {
      api.reload('094c60fa', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=094c60fa&scoped=true&", function () {
      api.rerender('094c60fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4R375Y0VliM7T/JS/teamMember.vue"
export default component.exports